import { css } from 'styled-components'

export const NoWrapEllipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
